// Set and Get the UserInfo related data from session storage

export const setUserInfo = (data: Record<string, any>) => {
  sessionStorage.setItem('userInfo', JSON.stringify(data));
};

export const getUserInfoSessionData = () => {
  try {
    const data = JSON.parse(sessionStorage.getItem('userInfo'));
    const { externalId = '', email = '' } = data || {};
    if (externalId || email) {
      return data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};



// WEBPACK FOOTER //
// ./utils/sessionUtil.ts